"use client";

import { ArrowUpRight, Globe, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function SupportInquiries() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.1
  });
  return <section id="support" ref={ref} className={cn("relative bg-background py-20 md:py-28 px-4 sm:px-6 lg:px-8 transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6")}>
      <div className="mx-auto max-w-3xl">
        <div className="relative overflow-hidden bg-card border border-border p-8 sm:p-12 text-center text-card-foreground shadow-lg flex flex-col items-center" style={{
        borderRadius: "var(--radius)"
      }}>
          {/* Subtle accent icon container */}
          <div className="mb-6 inline-flex h-14 w-14 items-center justify-center rounded-full bg-accent text-[hsl(228,100%,70%)] border border-border/50" aria-hidden="true">
            <Mail className="h-6 w-6 text-[hsl(228,100%,70%)]" strokeWidth={1.75} />
          </div>

          <h2 className="font-default font-bold text-3xl sm:text-4xl md:text-5xl tracking-tight text-foreground">
            Support Inquiries
          </h2>

          <p className="mt-4 max-w-xl text-base sm:text-lg leading-relaxed text-muted-foreground font-default">
            Questions about your collection or the app? Our team is happy to help.
          </p>

          <div className="mt-8 w-full sm:w-auto max-w-full">
            <Link to="mailto:support@getondeckapp.com" className="inline-flex w-full sm:w-auto items-center justify-center gap-2.5 px-8 py-4 bg-primary text-primary-foreground font-default font-semibold text-base sm:text-lg transition-colors duration-200 hover:opacity-90 shadow-md break-all sm:break-normal" style={{
            borderRadius: "var(--radius)"
          }}>
              <span className="truncate">support@getondeckapp.com</span>
              <ArrowUpRight className="h-5 w-5 shrink-0" />
            </Link>
          </div>

          <div className="mt-6 flex items-center justify-center gap-2 text-sm text-muted-foreground font-default">
            <Globe className="h-4 w-4 shrink-0" />
            <span>getondeckapp.com</span>
          </div>
        </div>
      </div>
    </section>;
}